import React, { Component } from 'react';
import { connect } from 'react-redux';

import * as BoardAction from '../../../../library/board/BoardAction';

import { values } from '../config';
import QuestionTabItem from './QuestionTabItem';

import { service } from '../../../common/configs';

const mapStateToProps = (state, ownProps) => {
    const top = state?.BoardReducer?.tagCategory?.top ?? {};
    return {
        top,
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        getTopTagMemberList: () => {
            return dispatch(
                BoardAction.getTopTagMemberList(
                    values.BOARD_TYPE,
                    values.BOARD_NAME
                )
            );
        },
    };
};

class QuestionTab extends Component {
    constructor(props) {
        super(props);

        this.onClickItem = this.onClickItem.bind(this);

        this.state = {
            list: [],
            selectedId: {},
        };
    }

    componentDidMount() {
        this.props.getTopTagMemberList().then(() => {
            return this.getData();
        });
    }

    onClickItem(category) {
        this.props.onClickTab(category.name);

        this.setState({
            selectedId: category.id,
        });
    }

    getData() {
        const { top, history } = this.props;
        const topTag = history.query.top_tag || 'Best';
        const list = [
            { id: 0, name: 'Best' },
            { id: 1, name: '전체' },
        ].concat(top);

        const selected = list.find((tag) => tag.name === topTag);

        this.setState({
            selectedId: selected ? selected.id : topTag === '전체' ? 1 : 0,
            list,
        });
    }

    renderList() {
        const { list, selectedId } = this.state;

        return list.map((categoryInfo, idx) => (
            <QuestionTabItem
                key={idx}
                categoryInfo={categoryInfo}
                selectedId={selectedId}
                onClickItem={this.onClickItem}
            />
        ));
    }

    render() {
        return <ul className="tab-type cell-8">{this.renderList()}</ul>;
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(QuestionTab);
